import React from "react"
import "./requirement.sass"
import { defaultIntl } from "../../utils"
import iconDriverRequirement from "../../images/driver/icon-driver-requirement.png"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="driver-requirement">
      <div className="container">
        <div className="columns is-vcentered">
          {/* <div className="column is-1"></div> */}
          <div className="column is-4">
            <img src={iconDriverRequirement} alt="Driver Requirement" className="" />
          </div>
          <div className="column is-8 ">
            <div className="text-content">
              <h2>{intl.formatMessage({ id: "driver.requirement.title" })}</h2>
              <p>
                <pre>{intl.formatMessage({ id: "driver.requirement.desc1" })}</pre>
                <pre>{intl.formatMessage({ id: "driver.requirement.desc2" })}</pre>
                <pre>{intl.formatMessage({ id: "driver.requirement.desc3" })}</pre>
                <pre>{intl.formatMessage({ id: "driver.requirement.desc4" })}</pre>
                <pre>{intl.formatMessage({ id: "driver.requirement.desc5" })}</pre>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
